<template>
  <div class="table-list">
    <el-table :data="tableData" border style="width: 100%">
      <!-- <el-table-column
        type="index"
        :index="indexMethod"
        align="center"
        width="50"
      ></el-table-column> -->
      <el-table-column :label="$t('VehicleManagement.partName')" align="center" prop="materialName">
      </el-table-column>
      <el-table-column :label="$t('VehicleManagement.unitPrice')" align="center" prop="unitPrice">
      </el-table-column>
      <el-table-column align="center" :label="$t('VehicleManagement.num')" prop="number">
      </el-table-column>
      <el-table-column align="center" :label="$t('VehicleManagement.amount')" prop="cost">
      </el-table-column>
      <el-table-column align="center" :label="$t('common.remarks')" prop="remarks">
      </el-table-column>
    </el-table>
  </div>
</template>   
<script>
export default {
  data() {
    return {
      tableData: [],
      id:''
    };
  },
  methods: {
    getDetailList() {
      let param = {
        id: this.id,
        pageNum: 1,
        pageSize: 100000,
      };
      this.$store.dispatch("MaintenanceManagement/GET_QUERYORDERLIST", param)
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              this.tableData = res.data.data.list[0].maintainMaterialPoList;
            }
          }
        })
        .catch((err) => {});
    },
    
    indexMethod(index) {
      return index + 1;
    },
  },
};
</script>

<style lang="less" scoped>
.table-list {
  /deep/.el-button {
    background-color: transparent;
    border: none;
    border-radius: 0;
  }

  /deep/.el-table--border {
    border-color: #ddd;
  }

  /deep/.el-table th {
    font-size: 14px;
    color: #333;
    background-color: #e8e8e8;
    padding: 0;
    height: 40px;
  }

  /deep/.el-table td {
    font-size: 13px;
    color: #333;
    height: 35px;
    padding: 0;
  }

  /deep/.el-table--border th,
  /deep/.el-table--border td {
    border-bottom-color: #ddd;
    border-right-color: #ddd;
  }

  /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: #efefef;
  }

  /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
  /deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #5f77fd;
    border-color: #5f77fd;
  }

  /deep/.el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #5f77fd;
  }

  /deep/.el-table .cell,
  .el-table th div {
    padding: 0;
  }

  /deep/.el-tag {
    background-color: #5f77fd;
    font-size: 13px;
    color: #fff;
    width: 60px;
    height: 24px;
    line-height: 24px;
    border: none;
  }

  /deep/.iconicon-chakanxq:before {
    color: #5f77fd;
  }
}
</style>